import http from "../../http-common";
/* eslint-disable */
class KeseminatanService {
  keseminatanList(page, itemPerPage, keyword) {
    return http.get(
      "/keseminatan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  getKeseminatan(id) {
    return http.get(`/keseminatan/${id}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data, foto) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    if (data.konten) bodyFormData.append("konten", data.konten);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.text);
    }

    if (foto != null) bodyFormData.append("photo", foto);

    return http.post("/keseminatan", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data, foto) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("nama", data.nama);
    if (data.konten) bodyFormData.append("konten", data.konten);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("data_status", data.selectedHide.text);
    }

    if (foto != null) bodyFormData.append("photo", foto);

    return http.put(`/keseminatan/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/keseminatan/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new KeseminatanService();
